export default __webpack_public_path__ + "static/media/kitchenBG.9da2b60b.jpg";